import { render, staticRenderFns } from "./Amazon.vue?vue&type=template&id=020f08d6&"
import script from "./Amazon.vue?vue&type=script&lang=js&"
export * from "./Amazon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports